(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/prolong-button.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/prolong-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const {
  useSetAtom
} = jotai;
const {
  wagerToProlongAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const ProlongButton = _ref => {
  let {
    wager,
    desc = '',
    text = false
  } = _ref;
  const setWagerToProlongAtom = useSetAtom(wagerToProlongAtom);
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'result-lyckoplatsen',
      action: 'click-forlang-spel',
      opt_label: "forlang".concat(desc ? "_".concat(desc) : '')
    });
    setWagerToProlongAtom(wager);
  };
  return React.createElement(Button, {
    onClick: handleClick,
    block: true,
    className: "lp-green",
    size: 300
  }, text ? text : 'Förläng lyckoplatsen');
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  ProlongButton
});

 })(window);